import { useQuery } from '@tanstack/react-query';

import type { UserRolePermissionsOutput, UserRolePermissionsResponse } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/users/:userId/permissions` — rôles + permissions d'un utilisateur.
 *
 * Consommé par :
 * - `AccountContext` : appelle avec `claims.id` pour détecter `EXTRANET_ADMIN`
 *   et activer le module Admin (sidebar + route)
 * - `UserRolesModal` : appelle avec `user.id` pour pré-cocher les rôles
 *   actuels avant édition (garantit un état frais, vs. snapshot de la liste)
 */
export const useUserRolesPermissions = (userId: string | null | undefined) =>
  useQuery({
    queryKey: extranetQueryKeys.users.permissions(userId ?? ''),
    queryFn: () =>
      getExtranetApi().get<Record<string, never>, UserRolePermissionsResponse['data']>(
        `/v1/users/${encodeURIComponent(userId!)}/permissions`,
        {},
      ),
    enabled: Boolean(userId),
    select: (data): UserRolePermissionsOutput => data,
  });
